import React from "react"
import { Switch, TextField, IconButton } from "@mui/material"
import { X } from "lucide-mui"
import i18n from "@/i18n"
import TimeRangeInput from "./time_range_input"

const STYLES = {
  specialItem: "flex items-center gap-4 p-4 rounded-lg border",
  scheduleItemOpen: "bg-gray-50 border-gray-200",
  scheduleItemClosed: "bg-red-50 border-red-300",
  statusLabel: "flex items-center gap-2 w-32",
} as const

interface SpecialHourItemProps {
  closed: boolean
  startDate: string
  endDate: string
  startTime: string
  endTime: string
  itemIndex?: number
  onClosedChange: (closed: boolean) => void
  onStartDateChange: (date: string) => void
  onEndDateChange: (date: string) => void
  onStartTimeChange: (time: string) => void
  onEndTimeChange: (time: string) => void
  onRemove: () => void
}

const SpecialHourItem: React.FC<SpecialHourItemProps> = ({
  closed,
  startDate,
  endDate,
  startTime,
  endTime,
  itemIndex,
  onClosedChange,
  onStartDateChange,
  onEndDateChange,
  onStartTimeChange,
  onEndTimeChange,
  onRemove,
}) => {
  return (
    <div
      className={`${STYLES.specialItem} ${closed ? STYLES.scheduleItemClosed : STYLES.scheduleItemOpen}`}
      data-testid={`settings-venue-hours-special-${itemIndex ?? 0}`}
    >
      <div className={STYLES.statusLabel}>
        <Switch
          checked={!closed}
          onChange={(e) => onClosedChange(!e.target.checked)}
          size="small"
          data-testid={`settings-venue-hours-special-${itemIndex ?? 0}-toggle`}
        />
        <span className={closed ? "text-red-600 font-medium" : "text-green-600 font-medium"}>
          {closed
            ? i18n.t("app.settings.venues.opening_hours.closed")
            : i18n.t("app.settings.venues.opening_hours.open")}
        </span>
      </div>

      <div className="flex items-center gap-2 flex-1">
        <TextField
          type="date"
          size="small"
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
          data-testid={`settings-venue-hours-special-${itemIndex ?? 0}-input-start-date`}
        />
        <span className="text-gray-600">-</span>
        <TextField
          type="date"
          size="small"
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
          data-testid={`settings-venue-hours-special-${itemIndex ?? 0}-input-end-date`}
        />
      </div>

      <TimeRangeInput
        startTime={startTime}
        endTime={endTime}
        disabled={closed}
        onStartTimeChange={onStartTimeChange}
        onEndTimeChange={onEndTimeChange}
      />

      <IconButton
        size="small"
        color="error"
        onClick={onRemove}
        data-testid={`settings-venue-hours-special-${itemIndex ?? 0}-btn-remove`}
      >
        <X className="w-4 h-4" />
      </IconButton>
    </div>
  )
}

export default SpecialHourItem
